module.exports = __webpack_public_path__ + "static/img/20231220_03.4850f27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2023/20231220_03.png
// module id = Wlx7
// module chunks = 0